import { deleteItem, getList, postItem } from "./generics";
import { fetchAuthenticated } from "./utils";
import { getAbsoluteUrl } from "./urls";
import { FAILED } from "../utils/constants/tags";
import TaxPayerApiKey from "../models/taxpayer-api-key";

export const getTaxPayerApiKeyList = (taxPayerId: number) => {
  const additionalParams = new Map<string, string>();
  additionalParams.set("tax_payer_id", taxPayerId.toString());
  return getList<TaxPayerApiKey>("/taxpayer_api_keys/", 100, 0, additionalParams);
};

export const createTaxPayerApiKey = (data: TaxPayerApiKey) => {
  return postItem("/taxpayer_api_keys/create/", data);
};

export const updateTaxPayerApiKey = async (
  id: number,
  data: Partial<TaxPayerApiKey>
) => {
  const fullUrl = getAbsoluteUrl(`/taxpayer_api_keys/${id}/`);
  try {
    const response = await fetchAuthenticated(fullUrl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PATCH",
      credentials: "include",
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch {
    return { status: FAILED, detail: "Server not Found" };
  }
};

export const revokeTaxPayerApiKey = (id: number) => {
  return deleteItem(`/taxpayer_api_keys/${id}/`, {});
};
